import React, { Component } from 'react'
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock, Alert } from 'react-bootstrap'
import { cloneDeep } from 'lodash'

const FieldGroup = ({ id, validationState, label, help, ...props }) => (
  <FormGroup controlId={id} validationState={!props.value ? 'error' : null}>
    <ControlLabel>{label}</ControlLabel>
    <FormControl {...props} />
    {help && <HelpBlock>{help}</HelpBlock>}
  </FormGroup>
)

export default class GroupModal extends Component {
  constructor() {
    super()
    this.state = { show: false, group: {}, modalTitle: '', errorMessage: '' }
  }

  add(customer) {
    let group = {}
    group.customer = customer
    this.setState({ group, show: true, modalTitle: 'Groep toevoegen' })
  }

  edit(group) {
    this.setState({ group: cloneDeep(group), show: true, modalTitle: 'Groep bewerken' })
  }

  onChange(property, value) {
    let group = this.state.group
    group[property] = value
    this.setState({ group })
  }

  close() {
    this.setState({ show: false, group: {}, errorMessage: '' })
  }

  isValid() {
    const group = this.state.group
    return group.name
  }

  onSave() {
    if (this.isValid()) {
      this.props
        .onSave(this.state.group)
        .then(() => {
          this.close()
          this.props.reload()
        })
        .catch((error) => this.setState({ errorMessage: this.getErrorMessage(error.response.data) }))
    }
  }

  getErrorMessage(type) {
    return 'Fout bij opslaan'
  }

  render() {
    const { show, modalTitle, group, errorMessage } = this.state
    return (
      <div>
        <Modal show={show} onHide={() => this.close()}>
          <Modal.Header>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {errorMessage && <Alert bsStyle="danger">{errorMessage}</Alert>}
            <FieldGroup
              type="text"
              label="Naam"
              className="group-name"
              value={group.name}
              onChange={(e) => this.onChange('name', e.target.value)}
            />
          </Modal.Body>

          <Modal.Footer>
            <Button bsStyle="danger" onClick={() => this.close()} id="cancel">
              Annuleren
            </Button>
            <Button bsStyle="success" onClick={() => this.onSave()} disabled={!this.isValid()} id="confirm">
              Opslaan
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
